/**
 * @generated SignedSource<<3b0c8bf5fea057e878e1abc615d3bd61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BalanceRefetchQuery$variables = {
  id: string;
};
export type BalanceRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"Balance_balance">;
  } | null;
};
export type BalanceRefetchQuery = {
  variables: BalanceRefetchQuery$variables;
  response: BalanceRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BalanceRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Balance_balance"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BalanceRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MoneyAmount",
                "kind": "LinkedField",
                "name": "amount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formatted",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Balance",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e2d005a6e10c95172d4f72714a6e908b",
    "id": null,
    "metadata": {},
    "name": "BalanceRefetchQuery",
    "operationKind": "query",
    "text": "query BalanceRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...Balance_balance\n    id\n  }\n}\n\nfragment Balance_balance on Balance {\n  id\n  amount {\n    formatted\n  }\n}\n"
  }
};
})();

(node as any).hash = "32e59d99455da971088506b6350b84aa";

export default node;
